import React from "react"
import CustomImage from "@/main/customImage"
import { Tabs, Tab, Col } from "react-bootstrap"

import SinglePropertyCarousel from "@/singleProperty/singlePropertyCarousel"
import VideoTour from "@/singleProperty/videoTour"
import Floorplans from "@/singleProperty/floorplans"
import PropertyMaps from "@/singleProperty/propertyMaps"

function NavTabs({ property }) {
    return (
        <>
            <Col xs={12} lg={7} className="mt-4">
                {/* Nav Tabs */}
                <Tabs
                    justify
                    defaultActiveKey="gallery"
                    id="single-property-tabs"
                >
                    <Tab
                        eventKey="gallery"
                        tabIndex="0"
                        title={
                            <div className="d-flex align-items-center justify-content-center">
                                <CustomImage
                                    src={
                                        "https://webb-jenkins-static-164679926.imgix.net/icons/gallery.svg"
                                    }
                                    alt="Gallery icon"
                                    height={20}
                                    width={20}
                                    className="my-auto"
                                />
                                <h2 className="h6 d-none d-md-inline ms-2 my-auto p-0">
                                    Gallery
                                </h2>
                            </div>
                        }
                    >
                        <Col xs={12} className="m-0 mt-4 p-0">
                            <SinglePropertyCarousel property={property} />
                        </Col>
                    </Tab>

                    {property.virtual_tours.length !== 0 && (
                        <Tab
                            eventKey="video"
                            tabIndex="0"
                            title={
                                <div className="d-flex align-items-center justify-content-center">
                                    <CustomImage
                                        src={
                                            "https://webb-jenkins-static-164679926.imgix.net/icons/video.svg"
                                        }
                                        alt="Video tour icon"
                                        height={20}
                                        width={26}
                                        className="my-auto"
                                    />
                                    <h2 className="h6 d-none d-md-inline ms-2 my-auto p-0">
                                        Video tour
                                    </h2>
                                </div>
                            }
                        >
                            <Col xs={12} className="m-0 mt-4 p-0">
                                <VideoTour property={property} />
                            </Col>
                        </Tab>
                    )}

                    {property.floorplans.length !== 0 && (
                        <Tab
                            eventKey="floorplan"
                            tabIndex="0"
                            title={
                                <div className="d-flex align-items-center justify-content-center">
                                    <CustomImage
                                        src={
                                            "https://webb-jenkins-static-164679926.imgix.net/icons/floorplan.svg"
                                        }
                                        alt="Floorplan icon"
                                        height={20}
                                        width={20}
                                        className="my-auto"
                                    />
                                    <h2 className="h6 d-none d-md-inline ms-2 my-auto p-0">
                                        Floorplans
                                    </h2>
                                </div>
                            }
                        >
                            <Col xs={12} className="m-0 mt-4 p-0">
                                <Floorplans property={property} />
                            </Col>
                        </Tab>
                    )}

                    <Tab
                        eventKey="map"
                        tabIndex="0"
                        title={
                            <div className="d-flex align-items-center justify-content-center">
                                <CustomImage
                                    src={
                                        "https://webb-jenkins-static-164679926.imgix.net/icons/maps.svg"
                                    }
                                    alt="Maps icon"
                                    height={20}
                                    width={24}
                                    className="my-auto"
                                />
                                <h2 className="h6 d-none d-md-inline ms-2 my-auto p-0">
                                    Maps
                                </h2>
                            </div>
                        }
                    >
                        <Col xs={12} className="m-0 mt-4 p-0">
                            <PropertyMaps property={property} />
                        </Col>
                    </Tab>
                </Tabs>
                {/* Nav Tabs End */}
            </Col>
        </>
    )
}

export default NavTabs
